/**
 * Mix-in for styled-components that checks whether the theme in the context
 * is the evolution theme.
 */
function isEvolution(style) {
  return ({
    theme
  }) => {
    if (theme !== null && theme !== void 0 && theme.isEvolutionRebrand) {
      return [style];
    }
    return null;
  };
}

export { isEvolution as i };
//# sourceMappingURL=isEvolution-DJMUxhiv.js.map
